import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconProfile: FC<ComponentProps<typeof IconWrapper>> = props => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0005 3.45381C6.38515 3.45381 3.4543 6.38466 3.4543 10.0001C3.4543 11.6459 4.06165 13.1498 5.06445 14.3C5.53523 13.6348 6.13746 13.069 6.83718 12.6395C7.10581 12.4747 7.38585 12.3317 7.67456 12.2114C6.86672 11.5422 6.35211 10.5314 6.35211 9.40039C6.35211 7.38541 7.98557 5.75195 10.0005 5.75195C12.0155 5.75195 13.649 7.38541 13.649 9.40039C13.649 10.5314 13.1344 11.5421 12.3266 12.2113C12.6153 12.3317 12.8953 12.4746 13.164 12.6395C13.8637 13.069 14.4659 13.6348 14.9367 14.3C15.9395 13.1498 16.5468 11.6458 16.5468 10.0001C16.5468 6.38466 13.6159 3.45381 10.0005 3.45381ZM13.9771 15.2005C13.5943 14.6133 13.0849 14.1164 12.4839 13.7475C11.767 13.3074 10.9465 13.0661 10.1068 13.0473C10.0715 13.0483 10.0361 13.0488 10.0005 13.0488C9.96503 13.0488 9.92964 13.0483 9.89436 13.0473C9.05461 13.0661 8.23418 13.3074 7.51723 13.7475C6.91623 14.1164 6.40683 14.6134 6.02399 15.2005C7.12632 16.0447 8.50485 16.5463 10.0005 16.5463C11.4963 16.5463 12.8748 16.0447 13.9771 15.2005ZM10.0968 11.7469C11.3492 11.6964 12.349 10.6651 12.349 9.40039C12.349 8.10338 11.2976 7.05195 10.0005 7.05195C8.70354 7.05195 7.65211 8.10338 7.65211 9.40039C7.65211 10.6652 8.65191 11.6964 9.90428 11.7469C9.93636 11.7464 9.96846 11.7461 10.0006 11.7461C10.0327 11.7461 10.0648 11.7464 10.0968 11.7469ZM2.1543 10.0001C2.1543 5.66669 5.66718 2.15381 10.0005 2.15381C14.3339 2.15381 17.8468 5.66669 17.8468 10.0001C17.8468 14.3334 14.3339 17.8463 10.0005 17.8463C5.66718 17.8463 2.1543 14.3334 2.1543 10.0001Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  )
}
